import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { jsx, Fragment } from 'react/jsx-runtime';
import { memo, useMemo } from 'react';
import { useWarzoneMap } from '../context/warzone-map.js';
var JumpLines = memo(function (_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useWarzoneMap = useWarzoneMap(),
    mapData = _useWarzoneMap.mapData;
  var path = useMemo(function () {
    if (!mapData) return "";
    var jumps = mapData.jumps;
    return jumps.map(function (_ref2) {
      var from = _ref2.from,
        to = _ref2.to;
      return "M".concat(from.x, ",").concat(from.y, " L").concat(to.x, ",").concat(to.y);
    }).join(" ");
  }, [mapData]);
  if (!mapData) return /* @__PURE__ */jsx(Fragment, {});
  return /* @__PURE__ */jsx("path", _objectSpread({
    id: "jump-lines",
    d: path
  }, args), "jump-lines");
});
JumpLines.displayName = "WarzoneMapJumpLines";
export { JumpLines };